import React, { useState } from "react";
import { makeStyles } from "@mui/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import { withStyles } from "@mui/styles";
import Dialog from "@mui/material/Dialog";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import CustomDialogTitle from "components/Dialog/CustomDialogTitle.js";
import Button from "components/CustomButtons/Button.js";
import AddIcon from "@mui/icons-material/Add";
import Tooltip from "@mui/material/Tooltip";
import { Menu, MenuItem } from "@mui/material";
import AddIndicDialog from "./AddIndicDialog.js";
import AddPointDialog from "./AddPointDialog.js";
import AddRealestateDialog from "./AddRealestateDialog.js";
import AddEquipmentDatatypeDialog from "./AddEquipmentDatatypeDialog.js";

const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

const useStyles = makeStyles(styles);

export default function AddValueToFormula(props) {
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [open3, setOpen3] = useState(false);
  const [open4, setOpen4] = useState(false);
  const [openMenu, setOpenMenu] = React.useState(null);
  const classes = useStyles();
  const handleClickMenu = (event) => {
    setOpenMenu(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setOpenMenu(null);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleClickOpen2 = () => {
    setOpen2(true);
  };
  const handleClose2 = () => {
    setOpen2(false);
  };
  const handleClickOpen3 = () => {
    setOpen3(true);
  };
  const handleClose3 = () => {
    setOpen3(false);
  };
  const handleClickOpen4 = () => {
    setOpen4(true);
  };
  const handleClose4 = () => {
    setOpen4(false);
  };
  return (
    <>
      <div>
        <Tooltip title="Ajouter une valeur">
          <Button
            onClick={handleClickMenu}
            color={"success"}
            className={classes.actionButton}
            style={{ marginTop: "30px" }}
          >
            <AddIcon fontSize="large" />
          </Button>
        </Tooltip>
        <Dialog
          onClose={handleClose}
          aria-labelledby="edituser-dialog-title"
          fullWidth="true"
          maxWidth="md"
          open={open}
        >
          <CustomDialogTitle id="customized-dialog-title" onClose={handleClose}>
            {"Ajour d'un indicateur"}
          </CustomDialogTitle>
          <DialogContent dividers>
            <AddIndicDialog
              closeModal={handleClose}
              formula={props.formula}
              setFormula={props.setFormula}
              indicatordata={props.indicatordata}
              serie={props.serie}
            />
          </DialogContent>
          <DialogActions></DialogActions>
        </Dialog>
        <Dialog
          onClose={handleClose2}
          aria-labelledby="edituser-dialog-title"
          fullWidth="true"
          maxWidth="md"
          open={open2}
        >
          <CustomDialogTitle id="customized-dialog-title" onClose={handleClose2}>
            {"Ajour d'un point de donnée"}
          </CustomDialogTitle>
          <DialogContent dividers>
            <AddPointDialog
              closeModal={handleClose2}
              formula={props.formula}
              setFormula={props.setFormula}
              pointdata={props.pointdata}
              avalaibleDico={props.avalaibleDico}
              serie={props.serie}
            />
          </DialogContent>
          <DialogActions></DialogActions>
        </Dialog>
        <Dialog
          onClose={handleClose3}
          aria-labelledby="edituser-dialog-title"
          fullWidth="true"
          maxWidth="md"
          open={open3}
        >
          <CustomDialogTitle id="customized-dialog-title" onClose={handleClose3}>
            {"Ajour d'une propriété du patrimoine"}
          </CustomDialogTitle>
          <DialogContent dividers>
            <AddRealestateDialog
              closeModal={handleClose3}
              formula={props.formula}
              setFormula={props.setFormula}
              serie={props.serie}
            />
          </DialogContent>
          <DialogActions></DialogActions>
        </Dialog>
        <Dialog
          onClose={handleClose4}
          aria-labelledby="edituser-dialog-title"
          fullWidth="true"
          maxWidth="md"
          open={open4}
        >
          <CustomDialogTitle id="customized-dialog-title" onClose={handleClose4}>
            {"Ajour d'un type de donnée équipement"}
          </CustomDialogTitle>
          <DialogContent dividers>
            <AddEquipmentDatatypeDialog
              closeModal={handleClose4}
              formula={props.formula}
              setFormula={props.setFormula}
              serie={props.serie}
              equipmentdatatype={props.equipmentdatatype}
            />
          </DialogContent>
          <DialogActions></DialogActions>
        </Dialog>
      </div>
      <Menu
        id="chart-menu"
        className={"chart-menu"}
        anchorEl={openMenu}
        keepMounted
        aria-haspopup={'menu'}
        open={Boolean(openMenu)}
        onClose={handleCloseMenu}
      >
        <MenuItem
          onClick={() => {
            handleClickOpen();
            handleCloseMenu();
          }}
          key={`handlegroup`}>
          Indicateur
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleClickOpen2();
            handleCloseMenu();
          }}
          key={`handledetail`}>
          Point de donnée
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleClickOpen3();
            handleCloseMenu();
          }}
          key={`handledetail`}>
          Propriété du patrimoine
        </MenuItem>
        {
          props.charttype === 'tabequipment' ?
            <MenuItem
              onClick={() => {
                handleClickOpen4();
                handleCloseMenu();
              }}
              key={`handledetail`}>
              Type de donnée équipement
            </MenuItem> : <></>
        }
      </Menu>
    </>
  );
}
